<template>
    <div>
      <div class="home">
        <div>
          <p class="home-span">第三方信息共享清单</p>
        </div>
      </div>
      <div class="box">
          <p class="box-2">当你使用第三方提供的服务时，我们会在获得或确保第三方获得你的授权同意后，以及其他符合法律法规规定的情形下共享对应信息。你可以通过本清单中列举的相关信息了解第三方会如何处理你的个人信息。我们也会对第三方获取个人信息的行为进行严格约束，以保护你的个人信息安全</p>
        <div>

          <table class="dataintable">
              <tr>
                <th>SDK名称</th>
                <th>第三方主体</th>
                <th>共享的信息</th>
                <th>使用场景和目的</th>
                <th>第三方个人信息处理规则</th>
              </tr>
            
              <tr>
                <td>阿里云短视频SDK</td>
                <td>阿里云计算有限公司</td>
                <td>设备信息和个人信息</td>
                <td>阿里云短视频合拍</td>
                <td><a href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112151438_20307.html">[链接]</a></td>
              </tr>
              <tr>
                <td>Bugly SDK</td>
                <td>深圳市腾讯计算机系统有限公司</td>
                <td>设备信息和个人信息</td>
                <td>应用发生崩溃时的信息采集，方便开发者解决崩溃问题</td>
                <td><a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56">[链接]</a></td>
              </tr>
              <tr>
                <td>抖音开放平台SDK</td>
                <td>北京微播视界科技有限公司</td>
                <td>个人信息</td>
                <td>分享视频到抖音平台</td>
                <td><a href="https://developer.open-douyin.com/docs/resource/zh-CN/dop/operation-standard/service-protocol/douyinsdk_pingtaiyinsizhengce">[链接]</a></td>
              </tr>
              <tr>
                <td>Mob ShareSDK</td>
                <td>上海游昆信息技术有限公司</td>
                <td>个人信息</td>
                <td>社会化分享</td>
                <td><a href="https://www.mob.com/wiki/detailed?wiki=638&id=14">[链接]</a></td>
              </tr>
              <tr>
                <td>声通SDK</td>
                <td>苏州声通信息科技有限公司</td>
                <td>麦克风录音</td>
                <td>实现录音评测功能，帮助用户提升发音水平</td>
                <td><a href="https://www.isuntone.com/sdk/sdk-policy.html">[链接]</a></td>
              </tr>
              
          </table>
  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import "../css/home.css";
  import rem from "../utils/rem";
  export default {
    name: "Home",
    components: {},
  };
  </script>
  